import React from 'react';
import { categoriesData } from '../Home/categoriesData';
import { useSuccessionTheme } from '../Succession/SuccessionThemeProvider';

const OpportunitiesToolsGrid = () => {
  const { company } = useSuccessionTheme ? useSuccessionTheme() : { company: {} };
  const secondaryBg = (company && company.secondary_color) || 'var(--succession-secondary)';
  const cat = (categoriesData || []).find((c) => c.id === 'opportunity');
  const tools = (cat && cat.tools) || [];

  return (
    <div className="bg-succession-bg-primary overflow-hidden shadow-succession-md rounded-lg border border-succession-border">
      {/* Compact header - for sidebar usage */}
      <div className="px-6 pt-6 pb-4">
        <h3 className="font-semibold text-lg text-succession-text-primary leading-tight" style={{ margin: 0, padding: 0 }}>Popular Tools</h3>
        <p className="text-sm text-succession-text-secondary leading-tight" style={{ margin: 0, padding: 0 }}>Quick access to your tools</p>
      </div>

      {/* Tools Grid */}
      <div className="px-6 pb-6">
        <div className="flex flex-wrap gap-x-6 gap-y-4 items-start">
          {tools.map((tool) => (
            <a
              key={tool.id || tool.label}
              href={tool.route || tool.href || '#'}
              className="flex flex-col items-center gap-2 p-2 rounded-md hover:bg-succession-hover-bg text-succession-text-secondary hover:text-succession-text-primary text-sm text-center w-32 md:w-36 shrink-0"
            >
              <div className="rounded-2xl flex items-center justify-center" style={{ width: '56px', height: '56px', backgroundColor: secondaryBg }}>
                {tool.icon ? (<tool.icon className="w-8 h-8 md:w-9 md:h-9 text-white" />) : (<span className="w-8 h-8" />)}
              </div>
              <span className="font-medium leading-snug text-succession-text-primary text-center whitespace-normal break-words">{tool.label}</span>
              {tool.comingSoon && <span className="text-[10px] text-gray-400">Soon</span>}
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default OpportunitiesToolsGrid;
